import { motion } from "framer-motion";
import {BookOpen, MessageCircleDashed as MessageCircle, Users, TrendingUp, Award} from 'lucide-react';

const differentials = [
{
  icon: <BookOpen className="w-7 h-7 text-blue-900" />,
  title: "É estruturado",
  desc: "Você sabe exatamente o que estudar",
  color: "border-blue-600"
},
{
  icon: <MessageCircle className="w-7 h-7 text-blue-900" />,
  title: "É prático",
  desc: "Você fala desde a primeira semana",
  color: "border-red-600"
},
{
  icon: <Users className="w-7 h-7 text-blue-900" />,
  title: "É acompanhado por professores reais",
  desc: "Não é você sozinho contra a plataforma",
  color: "border-blue-600"
},
{
  icon: <TrendingUp className="w-7 h-7 text-blue-900" />,
  title: "É progressivo",
  desc: "Cada aula constrói a próxima",
  color: "border-red-600"
},
{
  icon: <Award className="w-7 h-7 text-blue-900" />,
  title: "É validado",
  desc: "Por mais de 10.000 alunos",
  color: "border-blue-600"
}];


export default function WhyItWorks() {
  return (
    <section className="bg-white md:py-20 pt-[40px] pb-[40px]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-serif text-3xl md:text-4xl font-bold text-blue-900 text-center mb-12">

          O método EW é diferente porque:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {differentials.map((d, i) =>
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            className={`bg-gray-50 rounded-2xl p-6 border-t-4 ${d.color} hover:shadow-md transition-shadow duration-300`}>

              <div className="flex items-center gap-3 mb-3">
                {d.icon}
                <h3 className="font-bold text-blue-900 text-lg">
                  {d.title}
                </h3>
              </div>
              <p className="text-gray-600 text-sm">{d.desc}</p>
            </motion.div>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center space-y-1">

          <p className="text-gray-700 text-lg">Você não fica perdido.</p>
          <p className="text-gray-700 text-lg">Você não fica pulando conteúdo.</p>
          <p className="text-blue-900 text-lg font-bold">Você segue um caminho claro.</p>
          <p className="text-red-600 text-xl font-bold mt-2">E isso muda tudo.</p>
        </motion.div>
      </div>
    </section>);

}